import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

const TITLE = 'Place Order | Force Fleet Tracking';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'force-order-app';

  constructor(private titleService: Title) {}

  ngOnInit(): void {
    this.titleService.setTitle(TITLE);
  }
}
